import styled from 'styled-components'
import { IconFont } from '../iconfont'
import { SetStateAction } from 'react'
interface BatchOperationProps<K> {
  selectedRowKeys: Array<K>
  selectedSubRowKeys?: Array<K>
  batchOperation: React.ReactNode
  setSelectedRowKeys: (item: never) => void | React.Dispatch<SetStateAction<K[]>>
  setSelectedSubRowKeys?: (item: never) => void | React.Dispatch<SetStateAction<K[]>>
}
export const BatchOperation: React.FC<BatchOperationProps<string>> = ({
  selectedRowKeys,
  selectedSubRowKeys,
  batchOperation,
  setSelectedRowKeys,
  setSelectedSubRowKeys,
}) => (
  <Container>
    {(selectedSubRowKeys?.length > 0 || selectedRowKeys?.length > 0) && batchOperation && (
      <div className="batch">
        <div className="flex">{batchOperation}</div>
        <div
          className="end"
          onClick={() => {
            setSelectedRowKeys([])
            if (selectedSubRowKeys) {
              setSelectedSubRowKeys([])
            }
          }}
        >
          <IconFont type="icon-guanbi" className="close" />
        </div>
      </div>
    )}
  </Container>
)
const Container = styled.div`
  .batch {
    height: 32px;
    background: #f1f3f8;
    border-radius: 8px;
    border: 1px solid #d3d5e6;
    margin-bottom: 12px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .flex {
      display: flex;
      align-items: center;
    }
    .end {
      width: 18px;
      height: 18px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s;
      cursor: pointer;
      &:hover {
        background: #ffffff;
      }
      &:active {
        box-shadow: 0px 0px 8px 2px #fffffff7;
      }
    }
    .close {
      font-size: 12px;
      color: #999999;
    }
  }
`
